import React, { ReactNode } from "react";

import classnames from "classnames";

import styles from "./DataTable.scss";
import { NestedTableCell } from "./NestedTableCell";
import { TableCell } from "./TableCell";
import type { Alignment, DataKey, TableColumn } from "./types";

interface TableRowProps {
  columns: TableColumn[];
  dataItem: any;
  defaultAlignment?: Alignment;
  isExpanded?: boolean;
  renderExpandedRowContent?: () => ReactNode;
  rowNumber?: number;
  enableNestedRows?: boolean;
  nestedLevel?: number;
  showCheckboxes?: boolean;
  onToggleSelectOne: () => void;
  dataKey: (dataItem: any) => DataKey;
}

export function TableRow({
  columns,
  dataItem,
  defaultAlignment,
  isExpanded,
  renderExpandedRowContent,
  rowNumber,
  enableNestedRows,
  nestedLevel,
  showCheckboxes,
  onToggleSelectOne,
  dataKey,
}: TableRowProps) {
  const mainRowClassNames = classnames(styles.row, {
    [styles["row--underlined"]]: !isExpanded,
  });

  return (
    <>
      <tr className={mainRowClassNames}>
        {columns.map(({ header, alignment, renderCell, width }, index) => {
          const key = `${header}-row-${rowNumber}-cell-${index}`;
          if (!enableNestedRows || index !== 0) {
            return (
              <TableCell
                key={key}
                alignment={alignment || defaultAlignment}
                renderCell={renderCell}
                dataItem={dataItem}
                width={width}
              />
            );
          } else {
            return (
              <NestedTableCell
                key={key}
                alignment={alignment || defaultAlignment}
                renderCell={renderCell}
                dataItem={dataItem}
                nestedLevel={nestedLevel}
                onToggleSelectOne={onToggleSelectOne}
                withCheckbox={showCheckboxes}
                width={width}
                dataKey={dataKey}
              />
            );
          }
        })}
      </tr>
      {!enableNestedRows && isExpanded && renderExpandedRowContent && (
        <ExpandedRow colSpan={columns.length}>
          {renderExpandedRowContent()}
        </ExpandedRow>
      )}
    </>
  );
}

function ExpandedRow(
  props: React.PropsWithChildren<{
    colSpan: number;
  }>
) {
  const { children, colSpan } = props;
  return (
    <tr className={styles["expanded_row"]}>
      <td colSpan={colSpan}>
        <div className={styles["expanded_row_content"]}>{children}</div>
      </td>
    </tr>
  );
}
